import { render } from "./DepotPriceChangeLog.vue?vue&type=template&id=773c48a0"
import script from "./DepotPriceChangeLog.vue?vue&type=script&lang=js"
export * from "./DepotPriceChangeLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__